import { RouteDictionary } from '@deltek/specification-client/core/Models/routeTypes'
import ProjectImportPage from 'pages/ProjectsPage/ProjectImportPage'
import { lazy } from 'react'

const ElementLibraryPageLazy = lazy(
    () => import('pages/StudioPage/ElementLibrary')
)
const TaskManagerPageLazy = lazy(() => import('pages/StudioPage/TaskManager'))
const OfficeMasterReportsPageLazy = lazy(
    () =>
        import('pages/StudioPage/ElementLibrary/OfficeMasterReportsPage/index')
)

export const StudioPageRoutes: RouteDictionary = {
    '/': {
        redirect: '/element-library',
    },
    '/element-library': {
        component: ElementLibraryPageLazy,
    },
    '/report': {
        component: OfficeMasterReportsPageLazy,
    },
    '/dashboard': {
        component: TaskManagerPageLazy,
    },
    '/import': {
        component: ProjectImportPage,
    },
}
